import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Button } from 'react-bootstrap';
import _ from 'lodash'

class WModal extends Component
{

  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show || false,
      title: this.props.title,
      message: this.props.message,
      btns: this.props.btns,
      auto_close: this.props.auto_close,
      callback: this.props.callback,
    }
  }

  componentDidMount(){

  }

  componentWillReceiveProps(nextProps) {
    
    this.setState(nextProps)
  }

  shouldComponentUpdate(nextProps, nextState) {
    
    return true;
  }

  componentWillUpdate(nextProps, nextState) {
    
  }

  static show(title="提醒", msg="", options)
  {
    const divTarget = document.createElement('div');

    document.body.appendChild(divTarget);

    const properties = {...options, 
      show:true,
      title:title, 
      message:msg
    }
    
    return ReactDOM.render(<WModal id={"wmodal_" + Math.floor(Date.now() / 1000)} {...properties} />, divTarget);
  }

  close() {
    this.setState({ show: false });
  }

  show() {
    this.setState({ show: true });
  }

  render()
  {
    
    const content = this.state
    
    var messages = content.message ?  (content.message instanceof Array ? content.message : [content.message]) : null;
    
    return (
      <Modal show={this.state.show} onHide={()=>this.close()}>
        <Modal.Header>
          <Modal.Title>{content.title}</Modal.Title>
        </Modal.Header>

        { ( messages != null || this.props.children) && 
           <Modal.Body>
          
            {_.isArray(messages) && messages.map( (item, index) => 
              <p key={index}>
                { item.split('\n').map((item, key) => {
                  return <span key={key}>{item}<br/></span>
                })}
              </p>
            ) }
           
            { this.props.children }
           </Modal.Body>
        }

        <Modal.Footer>
          {
            content.btns && content.btns.map((title, index)=>
              <Button bsStyle="primary" block 
               onClick={ (e) => {
                    this.state.callback(title) 
                    this.state.auto_close && this.close()
                  }
                }>{title}
              </Button>
            )
          }
        </Modal.Footer>
      </Modal>
    );
  }
}

WModal.defaultProps = {
  title: '提示',
  message: null,
  btns: ['確定'],
  auto_close: true,
  callback: ((title) => { console.log("按下" + title) })
}

export default WModal;



// WEBPACK FOOTER //
// ./src/components/WModal/WModal.js